/**
 * Extract error message from API response payload
 * Handles nested error structures and provides fallback
 *
 * @param {object} payload - Error response data
 * @returns {string} User-friendly error message
 */
export const getErrorMessage = (payload) => {
  if (payload && typeof payload === "object") {
    if (typeof payload.message === "string" && payload.message.trim()) {
      return payload.message.trim();
    }
    const inner = payload.data;
    if (
      inner &&
      typeof inner === "object" &&
      !Array.isArray(inner) &&
      typeof inner.message === "string" &&
      inner.message.trim()
    ) {
      return inner.message.trim();
    }
  }
  return "Unable to complete this step. Please try again.";
};
